import { isPlatformBrowser, Location as PageLocation } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute, Router } from '@angular/router';
import { SlugTextPipe } from 'avn/shared/pipes/slug-text.pipe';
import { toUrlSlug } from 'avn/shared/utils/url-slug.util';
import * as moment from 'moment';
import { Subject, Subscription, debounceTime } from 'rxjs';

import {
  AvaanaCategory,
  Location,
  LocationDropdownList,
  PopularServiceDatum,
  Prediction
} from '../../../interfaces/homepage';
import { ApiService } from '../../../services/api.service';
import { StoreService } from '../../../services/store.service';

import { SearchBoxPopComponent } from './search-box-pop/search-box-pop.component';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class SearchBoxComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private documentClickListener = (event: MouseEvent) => {
    const dropdowns = document.querySelectorAll('.search-input-box');
    if (dropdowns) {
      let opened = false;
      dropdowns.forEach((dropdown: Element) => {
        if (dropdown && !dropdown.contains(event.target as Node)) {
          dropdown.classList.remove('show');
        }
        if (dropdown.classList.contains('show')) {
          opened = true;
        }
      });
      if (!opened) {
        this.dropdownType = '';
      }
    }
  };

  dropdownType = '';
  todayDate = new Date();
  popularCategories: PopularServiceDatum[] = [];
  allServices: AvaanaCategory[] = [];
  serviceText = '';
  locationText = '';
  // businessList: BusinessSearchList[] = [];
  // healthConditions: HealthConditionList[] = [];
  searchType = '';
  locationTextChange = new Subject<string>();
  filteredLocationsList: LocationDropdownList[] = [];
  searchSlug = '';
  locationSlug = '';
  postCodeSlug = '';
  selectedDate = moment(this.todayDate);
  pageType = false;
  currentPage = '';
  extra_params: any;

  constructor(
    private api: ApiService,
    private store: StoreService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private slugText: SlugTextPipe,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: any,
    private pageLocation: PageLocation,
    private cd: ChangeDetectorRef
  ) {}

  currentView = 'list';

  @Input() showBack = true;
  @Input() viewType = 'normal';
  @Input() label = 'city, state';
  @Input() minDate: string;
  @ViewChild('locationInput') locationInput: ElementRef;

  ngOnInit(): void {
    this.extra_params = this.activatedRoute.snapshot.queryParams;
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('click', this.documentClickListener);
    }

    const searchBoxParamsSub = this.store.searchBoxParams.subscribe((params: any) => {
      const url_split = this.router.url.split('/');
      this.pageType = ['search', 'service', 'category', 'symptom'].includes(url_split[1]);
      this.currentPage = url_split[1];
      if (this.pageType) {
        if (url_split[1] === 'category') {
          this.serviceText = this.slugText.transform(params['category_name'], 'capitalize') as string;
        } else {
          this.serviceText = this.slugText.transform(params['service'], 'capitalize') as string;
        }
      }
      this.cd.detectChanges();
    });
    this.subscriptions.push(searchBoxParamsSub);

    const queryParamsSub = this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params?.['dt']) {
        this.selectedDate = moment(params?.['dt'], 'YYYY-MM-DD');
      }
    });
    this.subscriptions.push(queryParamsSub);

    const meraLocationSub = this.store.meraLocationSub.subscribe(() => {
      setTimeout(() => {
        this.setLocation();
      }, 10);
    });
    this.subscriptions.push(meraLocationSub);

    const locationTextSub = this.locationTextChange.pipe(debounceTime(500)).subscribe((value) => {
      this.getPlaces(value);
    });
    this.subscriptions.push(locationTextSub);

    if (isPlatformBrowser(this.platformId)) {
      this.fetchPopularCategories();
      this.fetchAllServices();
      // this.fetchAllBusinessList();
      // this.fetchAllHealthConditions();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    if (isPlatformBrowser(this.platformId)) {
      document.removeEventListener('click', this.documentClickListener);
    }
  }

  getPageType() {
    const url_split = this.router.url.split('/');
    return ['search', 'service', 'category', 'symptom'].includes(url_split[1]);
  }

  getServiceText() {
    return this.serviceText;
  }

  back() {
    this.pageLocation.back();
  }

  retryed = 0;

  setLocation() {
    const location = this.store.meraLocation;
    if (!location.city_name && this.retryed < 5) {
      setTimeout(() => {
        this.retryed += 1;
        console.info('Retryed location: ' + this.retryed);
        this.setLocation();
      }, 500);
    } else if (!location.city_name && this.retryed >= 5) {
      this.store.setDefaultLocation();
    }
    if (location.city_name) {
      const locInput = this.locationInput?.nativeElement;
      let locList: any = [];
      if (this.label) {
        this.label.split(', ').forEach((key: any) => {
          locList.push(this.store.meraLocation?.[key]);
        });
      } else {
        locList = [this.store.meraLocation.city_name, this.store.meraLocation.state_name].filter(
          (value) => value !== null && value !== undefined && value !== ''
        );
      }
      if (locInput) {
        locInput.value = locList.join(', ');
      }
      this.locationText = locList.join(', ');
      this.locationSlug = toUrlSlug(location.city_name);
      this.postCodeSlug = (location.post_code || '').toLowerCase();
    }
  }

  filteredPopularCategories() {
    if (this.serviceText) {
      return this.popularCategories.filter((c) => {
        return c.name.toLowerCase().includes(this.serviceText.toLowerCase());
      });
    }
    return this.popularCategories;
  }

  filteredAllServices() {
    if (this.serviceText) {
      return this.allServices.filter((c) => {
        return c.name.toLowerCase().includes(this.serviceText.toLowerCase());
      });
    }
    return this.allServices;
  }

  // filteredBusinesses() {
  //   if (this.serviceText) {
  //     return this.businessList.filter((c) => {
  //       return c.name.toLowerCase().includes(this.serviceText.toLowerCase());
  //     });
  //   }
  //   return [];
  // }

  // filteredHealthConditions() {
  //   if (this.serviceText) {
  //     return this.healthConditions.filter((c) => {
  //       return c.name.toLowerCase().includes(this.serviceText.toLowerCase());
  //     });
  //   }
  //   return [];
  // }

  // Fetching Data

  fetchPopularCategories() {
    const popularCategoriesSub = this.api.getPopularList().subscribe({
      next: (response: any) => {
        this.popularCategories = response.data;
      }
    });
    this.subscriptions.push(popularCategoriesSub);
  }

  fetchAllServices() {
    const allServicesSub = this.api.getAllServices().subscribe({
      next: (response: any) => {
        this.allServices = response.data.sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
    this.subscriptions.push(allServicesSub);
  }

  // fetchAllBusinessList() {
  //   this.api.getAllAvailableBusiness().subscribe({
  //     next: (response) => {
  //       this.businessList = response.data;
  //     }
  //   });
  // }

  // fetchAllHealthConditions() {
  //   this.api.getHealthConditions().subscribe({
  //     next: (response) => {
  //       this.healthConditions = response;
  //     }
  //   });
  // }

  searchInput() {
    if (this.serviceText === '') {
      this.searchType = '';
      this.searchSlug = '';
    }
  }

  dateChanged(e: any) {
    this.selectedDate = moment(e.value);
  }

  openDropdown(dropdown_type: string) {
    this.dropdownType = dropdown_type;
  }

  selectOption(name: string, search_type: string) {
    this.serviceText = name;
    this.dropdownType = '';
    this.searchType = this.searchType !== 'online' ? search_type : 'online';
    this.searchSlug = toUrlSlug(name);
  }

  selectBizOption(biz: any, search_type: string) {
    this.serviceText = biz.name;
    this.dropdownType = '';
    this.searchType = this.searchType !== 'online' ? search_type : 'online';
    this.searchSlug = biz.slug;
    this.locationSlug = toUrlSlug(biz.city);
  }

  selectLocation(location: LocationDropdownList, desktop = false) {
    this.locationText = location.displayText;
    const locationInput = document.getElementById('location-input') as HTMLInputElement;
    if (locationInput) {
      locationInput.value = location.displayText;
    }
    this.dropdownType = '';
    this.getReverseGeoCodeByAddress(location.prediction, desktop);
  }

  getmeraLocation() {
    this.store.fetchmeraLocation.next(true);
    this.dropdownType = '';
  }

  changeToOnline() {
    this.locationText = 'Online';
    this.searchType = 'online';
    const locationInput = document.getElementById('location-input') as HTMLInputElement;
    if (locationInput) {
      locationInput.value = 'Online';
    }
    this.dropdownType = '';
  }

  onLocationTextChanged(e: Event) {
    const inputElement = e.target as HTMLInputElement;
    const locInput = inputElement.value;
    if (locInput === '' || locInput === null) {
      this.clearLocation();
      return;
    }
    this.locationTextChange.next(locInput);
  }

  clearLocation() {
    this.filteredLocationsList = [];
  }

  private getPlaces(value: string) {
    this.filteredLocationsList = [];
    const query_string = value;
    this.getPlacePredictions(query_string).then((predictions) => {
      const predictions_list = <Prediction[]>predictions;
      for (let i = 0; i < predictions_list.length; i++) {
        const description = predictions_list[i].description;
        const idx = description.indexOf(', Australia');
        let locationDisplayText = description;
        if (idx !== -1) {
          locationDisplayText = description.substring(0, idx);
        }
        const item = {
          text: description,
          displayText: locationDisplayText,
          place_id: predictions_list[i].place_id,
          prediction: predictions_list[i]
        };
        this.filteredLocationsList.push(item);
      }
    });
  }

  private getPlacePredictions(query: string): Promise<any> {
    this.filteredLocationsList = [];
    const autocompleteSrv = new google.maps.places.AutocompleteService();
    return new Promise((resolve, reject) => {
      autocompleteSrv.getPlacePredictions(
        {
          types: ['geocode'],
          input: query,
          componentRestrictions: { country: 'AU' }
        },
        (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            resolve(predictions);
          } else {
            reject(status);
          }
        }
      );
    });
  }

  toSetLocation = new Location();
  fetchingLocation = false;
  getReverseGeoCodeByAddress(prediction: Prediction, desktop = false) {
    const address = prediction.description;
    this.fetchingLocation = true;
    const responseObs = this.api.getGeoCodingByAddress(address);
    responseObs.subscribe({
      next: (response) => {
        let state = '';
        let city = '';
        try {
          let postcode = '';

          if (response.geocode_details.results[0].address_components) {
            for (let i = 0; i < response.geocode_details.results[0].address_components.length; i++) {
              const component = response.geocode_details.results[0].address_components[i];
              if (component.types[0] === 'postal_code') {
                postcode = component.long_name;
              } else if (component.types[0] === 'administrative_area_level_1') {
                state = component.long_name;
              } else if (
                component.types[0] === 'locality' ||
                (component.types.length > 2 && component.types[1] === 'locality') ||
                (component.types.length > 3 && component.types[2] === 'locality')
              )
                city = component.long_name;
            }
          }
          if (postcode === '') {
            prediction.postal_code = this.setMajorCityAndSuburbInfo(city);
          } else {
            prediction.postal_code = postcode;
          }
          const lng = response.geocode_details.results[0].geometry.location.lng;
          const lat = response.geocode_details.results[0].geometry.location.lat;
          prediction.longitude = lng;
          prediction.latitude = lat;
        } catch (e) {
          console.info(e);
        }
        this.toSetLocation.lat = prediction.latitude;
        this.toSetLocation.lng = prediction.longitude;
        this.toSetLocation.post_code = prediction.postal_code;
        this.toSetLocation.city_name = city;
        this.toSetLocation.state_name = state;

        this.locationSlug = toUrlSlug(city);
        this.postCodeSlug = prediction.postal_code;
        this.fetchingLocation = false;

        if (this.toSetLocation?.city_name && this.toSetLocation.state_name && desktop) {
          this.store.setmeraLocation(this.toSetLocation);
        }
      }
    });
  }

  setMajorCityAndSuburbInfo(suburb: string) {
    const mc = suburb.toLowerCase();
    if (mc === 'brisbane') {
      return '4000';
    } else if (mc === 'perth') {
      return '6000';
    } else if (mc === 'melbourne') {
      return '3000';
    } else if (mc === 'adelaide') {
      return '5000';
    } else if (mc === 'sydney') {
      return '2000';
    }
    return '';
  }

  searchNow() {
    this.searchSlug === 'Health and wellbeing services' || this.searchSlug === 'all' ? '' : this.searchSlug;
    let url = '';
    const queryParams: any = {};
    if (this.searchType === 'online') {
      url = `/online/${this.searchSlug}`;
    } else {
      if (this.searchType === 'business') {
        url = `/provider/${this.searchSlug}/${this.locationSlug}`;
      } else if (this.searchType === 'service') {
        url = `/search/${this.searchSlug}/${this.locationSlug}`;
      } else if (this.searchType === 'health_condition') {
        url = `/search/health-condition/${this.searchSlug}/${this.locationSlug}`;
      } else {
        url = `/search/health-and-wellbeing-services/${this.locationSlug}`;
      }
      if (this.searchType !== 'business' && this.searchType !== 'online' && this.postCodeSlug) {
        url += `/${this.postCodeSlug}`;
      }
      if (this.searchType !== 'business' && this.selectedDate) {
        queryParams.dt = this.selectedDate.format('YYYY-MM-DD');
      }
    }
    if (this.toSetLocation?.city_name && this.toSetLocation.state_name) {
      this.store.setmeraLocation(this.toSetLocation);
    }
    this.router.navigate([url], {
      queryParams: this.extra_params
    });
  }

  locationFocus() {
    this.locationInput.nativeElement.value = '';
    this.locationText = '';
  }

  locationFocusOut(e: Event) {
    if ((e.target as HTMLInputElement).value === '') {
      let locList: any = [];
      if (this.label) {
        this.label.split(', ').forEach((key: any) => {
          locList.push(this.store.meraLocation?.[key]);
        });
      } else {
        locList = [this.store.meraLocation.city_name, this.store.meraLocation.state_name].filter(
          (value) => value !== null && value !== undefined && value !== ''
        );
      }
      this.locationText = locList.join(', ');
      this.locationInput.nativeElement.value = locList.join(', ');
    }
  }
  openMobilePop() {
    const dialogData: MatDialogConfig = {
      disableClose: false,
      hasBackdrop: true,
      width: '100%',
      maxWidth: '400px',
      height: '100%',
      maxHeight: '400px',
      panelClass: ['searchboxPanel', 'popup-container'],
      data: {
        service: this.serviceText,
        location: this.locationText,
        date: this.selectedDate,
        params: this.extra_params
      }
    };
    this.dialog.open(SearchBoxPopComponent, dialogData);
  }

  changeCurrentView() {
    this.currentView = this.currentView === 'list' ? 'map' : 'list';
    this.store.currentPageType.next(this.currentView);
  }
}
